import { render, staticRenderFns } from "./ConsultantOrdersSubMenuLinks.vue?vue&type=template&id=0761261c"
import script from "./ConsultantOrdersSubMenuLinks.vue?vue&type=script&lang=js"
export * from "./ConsultantOrdersSubMenuLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0761261c')) {
      api.createRecord('0761261c', component.options)
    } else {
      api.reload('0761261c', component.options)
    }
    module.hot.accept("./ConsultantOrdersSubMenuLinks.vue?vue&type=template&id=0761261c", function () {
      api.rerender('0761261c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/orders/ConsultantOrdersSubMenuLinks.vue"
export default component.exports